import httpClient from "./httpClient";

const base = "/default-signatures";

export function listDefaultSignatures() {
  return httpClient.get(base).then((res) => res.data.data);
}

export function saveDefaultSignature(payload) {
  return httpClient.post(base, payload).then((res) => res.data.data);
}

export function updateDefaultSignatureImage(signatureId, file) {
  const formData = new FormData();
  formData.append("file", file);
  return httpClient
    .post(`${base}/${signatureId}/image`, formData, { headers: { "Content-Type": "multipart/form-data" } })
    .then((res) => res.data.data);
}

export function deleteDefaultSignature(signatureId) {
  return httpClient.delete(`${base}/${signatureId}`).then((res) => res.data);
}
